import React from 'react';
import { Field } from 'formik';
import { FieldProps } from 'formik/dist/Field';

import InputMaskField, { Props } from '@components/FormElements/BaseFields/InputMask';

const FormikInputMaskField = ({ name, fieldProps, ...props }: Props) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const { error, touched } = form.getFieldMeta(field.name);
        return (
          <InputMaskField
            {...field}
            {...props}
            name={name}
            fieldProps={{ error: touched ? error : undefined, ...fieldProps }}
          />
        );
      }}
    </Field>
  );
};

export default FormikInputMaskField;
